import IdleVue from "idle-vue";
import store from '@/store'
export default {
    install(Vue, options) {

        const eventsHub = new Vue();
        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }

        Vue.use(IdleVue, {
            eventEmitter: eventsHub,
            store,
            idleTime: 30 * 60 * 1000, // minutes * 60 * 1000,
            startAtIdle: false
        });

    }
}